import { ImageConfigComplete, imageConfigDefault } from 'next/dist/shared/lib/image-config';

const configEnv =
  (process.env.__NEXT_IMAGE_OPTS as never as ImageConfigComplete | undefined) ?? imageConfigDefault;

export default configEnv;
